#import "../fragments/queued-email-fragment.graphql"

query GetScheduledEmails($limit: Int!, $cursor: String, $filters: EmailsQueuedFilterInput) {
    queuedEmails(first: $limit, after: $cursor, filters: $filters) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...QueuedEmail
            }
        }
    }
}
